import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { analyticsApi, type BIDashboard } from '../../api/analytics';

const NAV = [
  { to: '/analytics/executive', label: 'Executive Dashboard' },
  { to: '/analytics/kpis', label: 'KPI Manager' },
  { to: '/analytics/forecast', label: 'Forecast Center' },
  { to: '/analytics/decision', label: 'Decision Center' },
  { to: '/analytics/insights', label: 'AI Insights' },
  { to: '/analytics/search', label: 'Semantic Search' },
  { to: '/analytics/intelligence', label: 'Decision Intelligence' },
];

export function BIHubPage() {
  const [dashboard, setDashboard] = useState<BIDashboard | null>(null);
  const [error, setError] = useState('');

  useEffect(() => {
    void analyticsApi.biDashboard().then(setDashboard).catch((e) => setError(String(e)));
  }, []);

  const stats = dashboard
    ? [
        { label: 'Revenue', value: `₹${(dashboard.revenue / 100000).toFixed(1)}L`, sub: `${dashboard.revenue_growth.toFixed(1)}% growth` },
        { label: 'Orders', value: dashboard.orders, sub: `${dashboard.order_growth.toFixed(1)}% growth` },
        { label: 'Gross Profit', value: `₹${(dashboard.gross_profit / 100000).toFixed(1)}L`, sub: `${dashboard.margin_pct.toFixed(1)}% margin` },
        { label: 'Inventory Value', value: `₹${(dashboard.inventory_value / 100000).toFixed(1)}L`, sub: `${dashboard.inventory_turnover}x turnover` },
        { label: 'AI Credits', value: dashboard.ai_credit_consumption, sub: 'consumed' },
        { label: 'Automation', value: `${dashboard.automation_success}%`, sub: 'success rate' },
      ]
    : [];

  return (
    <div className="mx-auto max-w-6xl p-6">
      <h1 className="text-2xl font-semibold">Business Intelligence Platform</h1>
      <p className="mt-1 text-sm text-slate-600 dark:text-slate-400">
        Enterprise BI, executive dashboards, KPI engine, data warehouse and AI decision intelligence.
      </p>
      <nav className="mt-4 flex flex-wrap gap-3 text-sm">
        {NAV.map((l) => (
          <Link key={l.to} to={l.to} className="text-slate-700 hover:underline dark:text-slate-300">{l.label}</Link>
        ))}
      </nav>
      {error && <p className="mt-4 text-sm text-red-600">{error}</p>}
      {dashboard?.executive && (
        <div className="mt-6 rounded-xl border bg-white p-4 dark:border-slate-700 dark:bg-slate-900">
          <h2 className="font-medium">{dashboard.executive.headline}</h2>
          <p className="mt-2 text-sm text-slate-600 dark:text-slate-400">{dashboard.executive.summary}</p>
        </div>
      )}
      <div className="mt-6 grid gap-4 sm:grid-cols-2 lg:grid-cols-3">
        {stats.map((s) => (
          <div key={s.label} className="rounded-xl border bg-white p-4 dark:border-slate-700 dark:bg-slate-900">
            <p className="text-sm text-slate-500">{s.label}</p>
            <p className="mt-1 text-2xl font-semibold">{String(s.value)}</p>
            <p className="mt-0.5 text-xs text-slate-500">{s.sub}</p>
          </div>
        ))}
      </div>
    </div>
  );
}
